(function ($, Drupal) {
  'use strict';

  //Gallery PopUp
  Drupal.behaviors.remodalHandler = {
    initialized: false,
    attach: function (context) {
      if (!this.initialized) {
        this.initialized = true;
        this.init(context);
      }
    },
    init: function (context) {
      // Stop All videos from auto playing
      let videos = document.querySelectorAll('.remodal video');
      videos.forEach(function (video) {
        video.pause();
        video.currentTime = 0;
      });

      // This is used to make sure Iframes are not being loaded while the modal is not opened.
      let iframes = document.querySelectorAll('.remodal iframe');
      iframes.forEach(function (iframe) {
        iframe.setAttribute('data-src', iframe.src);
        iframe.setAttribute('src', ' ');
      });

      $(document).on('opening', '.remodal', function (e) {
        //////// If you want local video to play auto when modal opens,
        ///////  Video sound would be shockong to someone who might not expect a video when clicking on button.
        // let modalVideo = e.target.querySelector("video");
        // if(modalVideo) {
        //   modalVideo.play();
        // }

        let modalIframe = e.target.querySelector("iframe");
        if (modalIframe !== null && modalIframe !== undefined && modalIframe.dataset.hasOwnProperty('src')) {
          modalIframe.setAttribute('src', modalIframe.dataset.src);
        }
      });

      $(document).on('closing', '.remodal', function (e) {
        // Stop Video and restart
        let modalVideo = e.target.querySelector("video");
        if (modalVideo) {
          modalVideo.pause();
          modalVideo.currentTime = 0;
        }

        // Remove the src from iframe to stop it from playing
        let modalIframe = e.target.querySelector("iframe");
        if (modalIframe !== null && modalIframe !== undefined) {
          modalIframe.setAttribute('data-src', modalIframe.getAttribute('src'));
          modalIframe.setAttribute('src', " ");
        }
      });
    }
  };


}(jQuery, Drupal));
